"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTH_PARAM = exports.CUSTOMER_ID = exports.FACILITY_ID = exports.AUTH_HEADER = exports._FITPOS_FUNCTION_URL = void 0;
//TODO: Maybe find a prettier way to determine if the user is using technogym or fitapp
var overwrite = document.location.href.includes('technogym') ? 'technogym-sso' : 'fitpos';
var domain = document.location.href.includes('technogym') ?
    'https://technogym-sso-729907915433.europe-west1.run.app' : 'https://europe-west3-named-catcher-373207.cloudfunctions.net';
exports._FITPOS_FUNCTION_URL = domain + '/' + overwrite;
exports.AUTH_HEADER = "app-auth";
exports.FACILITY_ID = "facilityId";
exports.CUSTOMER_ID = "id";
exports.AUTH_PARAM = "auth";
